export default __webpack_public_path__ + "static/photoroom-logo-0a24939846d84d45d6d2512c242a9012.svg";